import { useState, useCallback, useEffect } from 'react';
import { useAppSelector } from 'app/store';
import { selectAdminUser } from 'features/auth/authSlice';

const TOUR_COMPLETED_KEY = 'nimax_welcome_tour_completed';

const getTourKey = (userId: string): string => `${TOUR_COMPLETED_KEY}_${userId}`;

export interface UseWelcomeTourReturn {
  showTour: boolean;
  openTour: () => void;
  closeTour: () => void;
  completeTour: () => void;
}

export const useWelcomeTour = (): UseWelcomeTourReturn => {
  const user = useAppSelector(selectAdminUser);
  const userId = user?._id;

  const [showTour, setShowTour] = useState(false);

  useEffect(() => {
    if (!userId) return;

    const tourCompleted = localStorage.getItem(getTourKey(userId));
    if (!tourCompleted) {
      const timer = setTimeout(() => setShowTour(true), 500);
      return () => clearTimeout(timer);
    }
  }, [userId]);

  const openTour = useCallback(() => {
    setShowTour(true);
  }, []);

  const closeTour = useCallback(() => {
    if (userId) {
      localStorage.setItem(getTourKey(userId), 'true');
    }
    setShowTour(false);
  }, [userId]);

  const completeTour = useCallback(() => {
    if (userId) {
      localStorage.setItem(getTourKey(userId), 'true');
    }
    setShowTour(false);
  }, [userId]);

  return { showTour, openTour, closeTour, completeTour };
};
